import { FormControl, FormGroup } from '@angular/forms';

/**
 * Returns form errors as a string
 * @param form Angular FormGroup
 * @returns string
 */
export function getFormValidationErrors(form: FormGroup): string {
  return Object.keys(form.controls)
    .map(control => {
      const controlErrors = form.get(control).errors;
      console.log(JSON.stringify(form.get(control).errors));
      if (!controlErrors) {
        return [];
      }
      const controlErrorsString = Object.keys(controlErrors)
        .flatMap(
          keyError =>
            `Key: ${keyError}: ${JSON.stringify(controlErrors[keyError])}`
        )
        .join(', ');
      return `Control ${control}: {${controlErrorsString}}`;
    })
    .filter(list => list.length > 0)
    .join('\n');
}

export function formRequiredFileType(type: string) {
  return function (control: FormControl) {
    const file = control.value;
    if (file) {
      const extension = file.name.split('.')[1].toLowerCase();
      if (type.toLowerCase() !== extension.toLowerCase()) {
        return {
          requiredFileType: true,
        };
      }

      return null;
    }

    return null;
  };
}

export function toFormData<T>(formValue: T) {
  const formData = new FormData();

  for (const key of Object.keys(formValue)) {
    const value = formValue[key];
    formData.append(key, value);
  }

  return formData;
}
